import ReviewScreen from 'features/advance/screens/registration/Review/ReviewScreen';
import React from 'react';

const ReviewPage = () => {
  return <ReviewScreen />;
};

export default ReviewPage;
